module.exports = __webpack_public_path__ + "static/gallery-meta-image-19a2b0d26c3c140095c7fa20b368ec44.jpg";